import Yup from '@fourthwall/utils/dist/yup'

export const validationSchema = Yup.object().shape({
  name: Yup.string().required().max(70).noHTML(),
  customerSupportEmail: Yup.string().email(),
  description: Yup.string().required().max(320).noHTML(),
  creatorName: Yup.string().required().max(100).noHTML(),
  socialImage: Yup.string(),
  socialImageType: Yup.string().oneOf(['Keep', 'Remove', 'New']),
})
